'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ApyCardsPerformanceError } from '../PerformanceDataList/ApyDataList';
import PerformanceSectionLayout from '../VaultPerformanceLayout';
const VaultPerformanceError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PerformanceSectionLayout testId="vault-v1-performance-error"><ApyCardsPerformanceError /></PerformanceSectionLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultPerformanceError);